module.exports = __webpack_public_path__ + "img/VPC-IT.b16c9e9.jpg";